import React from 'react';
import { Link } from 'react-router-dom';

export const Contacts = () => {
    return (
        <div>
            <h1 style={styles.main}>Contacts</h1>
            <div>
                <span>Cecilia Chapman
711-2880 Nulla St.
Mankato Mississippi 96522
(257) 563-7401
Iris Watson
P.O. Box 283 8562 Fusce Rd.
Frederick Nebraska 20620
(372) 587-2335
Celeste Slater
606-3727 Ullamcorper. Street
Roseville NH 11523
(786) 713-8616
Theodore Lowe
Ap #867-859 Sit Rd.
Azusa New York 39531
(793) 151-6230
Calista Wise</span>
            </div>
            <h2 style={styles.back}>
              <Link to="/">Back Home</Link>
            </h2>
        </div>
    )
}

const styles = {
    back: {
        textAlign: "center",
        margin: "100px"
    },
    main: {
        color: "yellow",
        textAlign: "center",
    }
}